import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import { MAX_RECORDING_SECONDS } from '../../api/transcribe';
import { useVoice } from '../../contexts/VoiceContext';
import { formatMMSS } from '../../helpers/datetime';
import { WaveBar } from './WaveBar';
import { VoiceModalListeningHints } from './VoiceModalListeningHints';

export const VoiceModalListeningView: FC = () => {
  const { recordingElapsedSeconds } = useVoice();
  const elapsed = formatMMSS(recordingElapsedSeconds);
  const maxDuration = formatMMSS(MAX_RECORDING_SECONDS);

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'center',
        minHeight: 120,
        gap: 1,
        width: '100%',
      }}
    >
      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent="center"
        gap={0.375}
        sx={{ height: 40, flexShrink: 0 }}
      >
        {Array.from({ length: 24 }).map((_, i) => (
          <WaveBar key={i} delay={i * 40} />
        ))}
      </Stack>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Text
          style={{
            fontSize: 12,
            fontVariantNumeric: 'tabular-nums',
            color: 'var(--tg-theme-hint-color)',
          }}
        >
          {`${elapsed} / ${maxDuration}`}
        </Text>
      </Box>

      <VoiceModalListeningHints />
    </Box>
  );
};
